import { useMemo } from 'react'
import { sanitiseCustomChart } from './helpers'

import { CustomChart } from '../../Dashboard/charts/CustomChart'
import { CustomChart as CustomChartType } from './types'

export const CustomChartPreview = ({
  chart,
}: {
  chart: Partial<CustomChartType>
}) => {
  const canShowPreview = useMemo(() => {
    if (
      !chart.items ||
      !chart.items.length ||
      !chart.chartType ||
      !chart.dataType ||
      !chart.colorScheme
    )
      return false
    return true
  }, [chart.chartType, chart.colorScheme, chart.dataType, chart.items])

  if (!canShowPreview)
    return (
      <div className="bg-gray-100 rounded-lg w-full h-[400px] animate-pulse" />
    )

  return <CustomChart chart={sanitiseCustomChart(chart)} />
}
